<div
  class="selector-bank-container"
  tabindex="1"
  appBanksSelector
  (isOpenChange)="selectorOpenChange($event)"
  [ngClass]="{ 'selector-bank-container--disabled': readonly }"
  #bankElement
>
  <div class="selected-bank-container">
    <div class="banks">
      <ng-container
        *ngIf="selectedBankStatesValue.length; else noBanksSelected"
      >
        <ng-container *ngFor="let bank of selectedBankStatesValue">
          <div
            class="bank-container {{ bank.status }}"
            [ngClass]="{ replaceable: bank.quoteId }"
            (click)="providerClicked(bank.shortName)"
          >
            <label>{{ bank.shortName }}</label>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div
      class="drop-down-button"
      *ngIf="availableBanks && availableBanks.length !== 1"
    ></div>
  </div>
  <div
    class="drop-down-container"
    [ngStyle]="{ 'width.px': widthOfBankElement }"
  >
    <div
      class="drop-down-inner-container"
      *ngIf="
        (!readonly && (banks | keyvalue).length) ||
        (bankToReplace && availableSubstitutes?.length)
      "
    >
      <ng-container *ngIf="!readonly; else replaceTheProvider">
        <div
          class="drop-down-option-container"
          *ngFor="let bank of banks | keyvalue; index as i"
        >
          <label
            class="drop-down-checkbox-label"
            [ngClass]="{
              disabled:
                selectedBankStatesValue.length >= 5 && !banks[bank.key].selected
            }"
          >
            <input
              type="checkbox"
              class="drop-down-checkbox"
              (input)="checkboxChange($any($event.target).checked, bank.key)"
              [checked]="$any(bank.value).selected"
              [disabled]="
                (selectedBankStatesValue.length >= 5 &&
                  !banks[bank.key].selected) ||
                readonly
              "
            />
            {{ bank.key }}
          </label>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #replaceTheProvider>
  <ng-container *ngIf="availableSubstitutes?.length">
    <div class="drop-down-inner-container__replacement-header">
      Replace {{ bankToReplace }} with provider:
    </div>
    <div
      class="drop-down-option-container"
      *ngFor="let bank of availableSubstitutes"
    >
      <button
        class="ui-button primary replacementProvider"
        (click)="replaceProvider(bank)"
      >
        {{ bank }}
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #noBanksSelected>
  <div class="bank-placeholder">
    <label> No Banks selected</label>
  </div>
</ng-template>
